document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll(".stats-bar").forEach(section => {

    const stats = section.querySelectorAll(".stat-num");

    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        const el = entry.target;

        const raw = el.dataset.target;
        const target = parseInt(raw.replace(/[^0-9]/g, ''));
        const suffix = raw.replace(/[0-9]/g, '');

        let current = 0;
        const increment = Math.ceil(target / 80);

        const timer = setInterval(() => {
          current = Math.min(current + increment, target);
          el.textContent = current.toLocaleString('en-IN') + suffix;

          if (current >= target) clearInterval(timer);
        }, 18);

        io.unobserve(el);
      });
    }, { threshold: 0.3 });

    stats.forEach(stat => io.observe(stat));

  });

});